import(/* webpackMode: "eager" */ "/app/src/app/itineraries/(map-layout)/loading.tsx");
